var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.0625C5.94922 2.0625 4.08984 3.15625 3.05078 4.90625C2.03906 6.68359 2.03906 8.84375 3.05078 10.5938C4.08984 12.3711 5.94922 13.4375 8 13.4375C10.0234 13.4375 11.8828 12.3711 12.9219 10.5938C13.9336 8.84375 13.9336 6.68359 12.9219 4.90625C11.8828 3.15625 10.0234 2.0625 8 2.0625ZM8 14.75C5.48438 14.75 3.1875 13.4375 1.92969 11.25C0.671875 9.08984 0.671875 6.4375 1.92969 4.25C3.1875 2.08984 5.48438 0.75 8 0.75C10.4883 0.75 12.7852 2.08984 14.043 4.25C15.3008 6.4375 15.3008 9.08984 14.043 11.25C12.7852 13.4375 10.4883 14.75 8 14.75ZM6.90625 9.9375H7.5625V8.1875H6.90625H6.25V6.875H6.90625H8.21875H8.875V7.53125V9.9375H9.09375H9.75V11.25H9.09375H6.90625H6.25V9.9375H6.90625ZM8.875 6H7.125V4.25H8.875V6Z",
    fill: "#0962AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleInfo);
export default __webpack_public_path__ + "static/media/circle-info.b3343b91778b47e72cf1b447b6182077.svg";
export { ForwardRef as ReactComponent };